module.exports = "query loadTasks{listTaskSummariesForUser{title description complete value action}}"